import { getNodesBounds, getViewportForBounds } from '@xyflow/react';
import { toPng } from 'html-to-image';

// Panels to hide during screenshot
const PANELS_TO_HIDE = [
  'tracer-right-panel',
  'tracer-top-panel',
  'tracer-controls-panel',
];

const PANELS_TO_HIDE_CLASSNAMES = [
  'tracer-controls-panel',
  'tracer-minimap',
  'react-flow__attribution',
];

const toggleElementVisibility = (isVisible) => {
  for (const id of PANELS_TO_HIDE) {
    const element = document.getElementById(id);
    if (!element) continue;
    element.style.display = isVisible ? 'block' : 'none';
  }

  for (const className of PANELS_TO_HIDE_CLASSNAMES) {
    const elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element) {
        element.style.display = isVisible ? 'block' : 'none';
      }
    }
  }
};

export const handleTracerScreenshot = async ({ action }) => {
  const { nodes } = action.params;
  try {
    // Get the ReactFlow viewport
    const viewportElement = document.querySelector('.react-flow__viewport');
    if (!viewportElement) {
      throw new Error('React Flow viewport not found');
    }

    // Hide panels for clean screenshot
    toggleElementVisibility(false);

    // Calculate bounds for all nodes
    const nodesBounds = getNodesBounds(nodes);

    const padding = 50;

    // Calculate required viewport dimensions with padding
    const fullWidth = nodesBounds.width - nodesBounds.x + padding * 2;
    const fullHeight = nodesBounds.height - nodesBounds.y + padding * 2;

    // Get the optimal viewport transformation
    const viewport = getViewportForBounds(
      nodesBounds,
      fullWidth,
      fullHeight,
      0.5,
      2,
      {
        x: 0,
        y: 0,
      }
    );

    try {
      // Create the image using toPng
      const dataUrl = await toPng(viewportElement, {
        backgroundColor: 'white',
        width: fullWidth,
        height: fullHeight,
        skipFonts: true,
        style: {
          width: `${fullWidth}px`,
          height: `${fullHeight}px`,
          transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
        },
        filter: (node) => {
          // Skip problematic elements that might cause loading issues
          if (node.tagName === 'LINK' && node.rel === 'stylesheet') {
            return !node.href || node.href.startsWith(window.location.origin);
          }
          // Skip external images that might cause CORS issues
          if (
            node.tagName === 'IMG' &&
            node.src &&
            !node.src.startsWith(window.location.origin) &&
            !node.src.startsWith('data:')
          ) {
            return false;
          }
          return true;
        },
      });

      return {
        screenshot: dataUrl,
      };
    } catch (error) {
      console.error('Error generating screenshot:', error);
      throw error;
    } finally {
      // Always restore visibility of elements
      toggleElementVisibility(true);
    }
  } catch (error) {
    console.error('Error capturing graph image:', error);
  }
};
